import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, Inject, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LGEDataService } from 'src/commons';
import { ConfirmModalComponent } from '..';


@Component({
    selector: 'compose-email-modal',
    templateUrl: './compose-email.component.html',
    styleUrls: ['./compose-email.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ComposeEmailModalComponent implements OnInit, OnDestroy {
    @Input('title') title: string;
    @Input('message') message: string;
    @Input('isNotSystemTemplateList') isNotSystemTemplateList: any;
    @Input('toAddList') toAddList: any;
    @Input() ccAddList: any;

    composeEmail: FormGroup;
    public confirm: any;
    isLoading: boolean = false;
    isAwardDeclineEmail = false;
    groupEmails = ['ADMIN', 'APPROVER', 'BASE', ' REVIEWER', 'TEST', 'CITAPPROVER', 'FOUNDATIONAPPROVER', 'PFTPAPPROVER', 'CITREVIEWER', 'FOUNDATIONBODREVIEWER', 'FOUNDATIONCCCREVIEWER'];
    // toAddList = ['Mayur.Chovatiya@lge-ku.com', 'b@b.bb', ' c@c.cc'];
    // emailTemplates = ['APPROVE', 'REJECT', 'SUBMIT', 'WITHDRAW'];
    editorConfig = {
        toolbar: [
            ["bold", "italic", "underline", "strikeThrough", "superscript", "subscript"],
            [{ 'align': [] }],
            [{ 'font': [] }],
            [{ 'color': [] }, { 'background': [] }],
            ['link', 'image', 'video'],                         
            ['emoji']
        ]
    };
    // editorConfig = {
    //     editable: true,
    //     spellcheck: false,
    //     height: '10rem',
    //     minHeight: '4rem',
    //     placeholder: 'Enter text here*...',
    //     translate: 'no',
    //     imageEndPoint: '',
    //     "toolbar": [
    //         ["bold", "italic", "underline", "strikeThrough", "superscript", "subscript"],
    //         ["justifyLeft", "justifyCenter", "justifyRight", "justifyFull"],
    //         ["fontName", "fontSize", "color"],
    //         ["link"]
    //     ]
    // };

    constructor(
        private _dataService: LGEDataService,
        private ref: ChangeDetectorRef,
        private dialog: MatDialog,
        private dialogRef: MatDialogRef<ComposeEmailModalComponent>,
        private fb: FormBuilder, @Inject(MAT_DIALOG_DATA) private data: any) {
        this.message = data.message;
        this.title = data.title;
        this.isNotSystemTemplateList = data.isNotSystemTemplateList;
        this.toAddList = data.toAddList;
        this.ccAddList = data.ccList;
        this.isAwardDeclineEmail = this.title.includes('Award');

    }

    ngOnInit() {
        this.createForms();
    }

    createForms(): void {
        this.composeEmail = this.fb.group({
            toAdd: ['', Validators.required],
            groupEmail: [''],
            ccAdd: [''],
            GroupCCEmail: [''],
            subject: ['', [Validators.maxLength(150)]],
            emailTemplate: [''],
            body: [''],
        });
        if (this.isAwardDeclineEmail) {
            this.composeEmail.controls['toAdd'].setValidators([]);
            this.composeEmail.controls['groupEmail'].setValidators([]);
        }
    }

    public showConfirm(title: string, message: string) {
        this.confirm = this.dialog.open(ConfirmModalComponent, {
            width: '350px',
            disableClose: false,
            data: { title: title, message: message }
        });
    }

    onSend() {

        this.showConfirm('Are you sure you want to send?', '');
        this.confirm.afterClosed().subscribe(result => {
            if (result === 'yes') {
                // console.log('form ', this.composeEmail.value)
                this.dialogRef.close(this.composeEmail.value);
            }
        });
    }


    selectTemplate(emailTemplate) {
        // // console.log(emailTemplate);
        if ((emailTemplate !== null) && (emailTemplate !== undefined)) {
            this.composeEmail.get('subject').setValue(emailTemplate.subject);
            this.composeEmail.get('body').setValue(emailTemplate.emailTemplateDescr);
        } else {
            this.composeEmail.get('subject').setValue('');
            this.composeEmail.get('body').setValue('');
        }
    }

    onCancel() {
        this.dialogRef.close();
    }

    ngOnDestroy() {

    }
}
